export default {
  appletTypeApi: {
      //轮播图配置
    appletType: {
        list: 'api/appletTypeApi/list',
        del: 'api/appletTypeApi/del',
        saveOrUpdate: 'api/appletTypeApi/saveOrUpdate'
      }

  }
}
